module.exports = __webpack_public_path__ + "static/media/webinar-vid.ec33a837.mp4";